import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseSupportTicketsTotalizerProps<T> = {
  filters?: {
    search?: string
    page?: number
    status?: string
    reason_id?: string
    responsible_id?: string
    responsible_id_nil?: boolean
    kind?: string
    createdAtStartDate?: string
    createdAtEndDate?: string
  }
  mapper?: (data: any) => T
}

export const useSupportTicketsTotalizer = <T,>({
  filters: { search = '', page, status, reason_id, responsible_id, responsible_id_nil, kind = 'external', createdAtStartDate, createdAtEndDate } = {},
  mapper = Mapper.default<T>(),
}: UseSupportTicketsTotalizerProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['supportTicketsTotalizer', page, search, status, reason_id, responsible_id, responsible_id_nil, kind, createdAtStartDate, createdAtEndDate],
    queryFn: () => {
      return privateAxios.get('/support/tickets/totalizer', {
        params: {
          search,
          page,
          'q[status_eq]': status,
          'q[reason_id_eq]': reason_id,
          'q[kind_eq]': kind,
          'q[responsible_id_eq]': responsible_id,
          'q[responsible_id_nil]': responsible_id_nil,
          'q[created_at_gteq]': createdAtStartDate,
          'q[created_at_lteq]': createdAtEndDate
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
